import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { getRandomColor } from '../../utils/colors';
import { useRandomLinkColors } from '../../utils/useRandomLinkColors';
const Navigation = () => {
  // Use our custom hook
  useRandomLinkColors();
  return <ul className="list-none space-y-4" data-id="element-542">
      <li className="flex" data-id="element-543">
        <span className="mr-2" data-id="element-544">↑</span>
        <Link to="/info" className="transition-colors duration-200" onMouseEnter={e => {
        e.currentTarget.style.color = getRandomColor();
      }} onMouseLeave={e => {
        e.currentTarget.style.color = '#333333';
      }} data-id="element-545">
          About
        </Link>
      </li>
      <li className="flex" data-id="element-546">
        <span className="mr-2" data-id="element-547">↑</span>
        <Link to="/photographs" className="transition-colors duration-200" onMouseEnter={e => {
        e.currentTarget.style.color = getRandomColor();
      }} onMouseLeave={e => {
        e.currentTarget.style.color = '#333333';
      }} data-id="element-548">
          Photography
        </Link>
      </li>
      <li className="flex" data-id="element-549">
        <span className="mr-2" data-id="element-550">↑</span>
        <Link to="/writing" className="transition-colors duration-200" onMouseEnter={e => {
        e.currentTarget.style.color = getRandomColor();
      }} onMouseLeave={e => {
        e.currentTarget.style.color = '#333333';
      }} data-id="element-551">
          Editorial
        </Link>
      </li>
      <li className="flex" data-id="element-552">
        <span className="mr-2" data-id="element-553">↑</span>
        <Link to="/books" className="transition-colors duration-200" onMouseEnter={e => {
        e.currentTarget.style.color = getRandomColor();
      }} onMouseLeave={e => {
        e.currentTarget.style.color = '#333333';
      }} data-id="element-554">
          Books
        </Link>
      </li>
      <li className="flex" data-id="element-555">
        <span className="mr-2" data-id="element-556">↑</span>
        <Link to="/workshops" className="transition-colors duration-200" onMouseEnter={e => {
        e.currentTarget.style.color = getRandomColor();
      }} onMouseLeave={e => {
        e.currentTarget.style.color = '#333333';
      }} data-id="element-557">
          Workshops
        </Link>
      </li>
      <li className="flex" data-id="element-558">
        <span className="mr-2" data-id="element-559">↑</span>
        <Link to="/news" className="transition-colors duration-200" onMouseEnter={e => {
        e.currentTarget.style.color = getRandomColor();
      }} onMouseLeave={e => {
        e.currentTarget.style.color = '#333333';
      }} data-id="element-560">
          News
        </Link>
      </li>
      <li className="flex" data-id="element-561">
        <span className="mr-2" data-id="element-562">↑</span>
        <Link to="/contact" className="transition-colors duration-200" onMouseEnter={e => {
        e.currentTarget.style.color = getRandomColor();
      }} onMouseLeave={e => {
        e.currentTarget.style.color = '#333333';
      }} data-id="element-563">
          Contact
        </Link>
      </li>
    </ul>;
};
export default Navigation;